import React from 'react';
import { Collapse, Space, Tag, Typography } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import { citationBadge } from '../utils/formatters';

const { Text } = Typography;

export default function CitationList({ citations = [], defaultOpen = false, forceOpen = false }) {
  if (!citations.length) return null;

  const collapseProps = forceOpen
    ? { activeKey: ['sources'] }
    : { defaultActiveKey: defaultOpen ? ['sources'] : [] };

  return (
    <Collapse
      className="glp1-sources-collapse"
      size="small"
      {...collapseProps}
      items={[
        {
          key: 'sources',
          label: <Text strong>Sources ({citations.length})</Text>,
          children: (
            <Space direction="vertical" size={8} style={{ width: '100%' }}>
              {citations.map((citation) => {
                const isExternal = citation.url && !String(citation.url).startsWith('local:');
                const badge = citationBadge(citation);
                const sourceMeta = [citation.speaker, citation.timestamp].filter(Boolean).join(' · ');
                const key = citation.citation_key || `${citation.source_id}-${citation.title}`;
                const titleNode = isExternal ? (
                  <a href={citation.url} target="_blank" rel="noopener noreferrer">
                    <LinkOutlined style={{ marginRight: 6 }} />
                    {citation.title}
                  </a>
                ) : (
                  <Text>{citation.title}</Text>
                );

                return (
                  <div key={key} className="glp1-source-row">
                    <span>
                      {titleNode}
                      {sourceMeta ? (
                        <Text type="secondary" style={{ display: 'block', fontSize: 12 }}>
                          {sourceMeta}
                        </Text>
                      ) : null}
                    </span>
                    <Tag color={badge.color}>{badge.label}</Tag>
                  </div>
                );
              })}
            </Space>
          ),
        },
      ]}
    />
  );
}
